namespace advisorop.services {
    `use strict`;

    export class CopyToClipboard {
        body: angular.IAugmentedJQuery;
        textarea: angular.IAugmentedJQuery;
        static $inject = [`$window`, `$q`];

        constructor(private $window: any, private $q: ng.IQService) {
            this.body = angular.element($window.document.body);
            this.textarea = angular.element('<textarea/>');
            this.textarea.css({
                position: 'fixed',
                opacity: '0'
            });
        }
        copy(toCopy): ng.IPromise<any> {
            var deferred = this.$q.defer();
            deferred.notify("copying the text to clipboard");
            this.textarea.val(toCopy);
            this.body.append(this.textarea);
            this.textarea.select();

            try {
                var successful = document.execCommand('copy');
                if (!successful) throw successful;
                deferred.resolve(successful);
            } catch (err) {
                deferred.reject(err);
                //					window.prompt("Copy to clipboard: Ctrl+C, Enter", toCopy);
            } finally {
                this.textarea.remove();
            }

            return deferred.promise;
        }
    }

    angular.module(Constants.ADVOP_SERVICES).service("copyToClipboard", CopyToClipboard);
}